// export const BASE_URL = "https://api-inforide.herokuapp.com";
// export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const BASE_URL = process.env.REACT_APP_BASE_URL;
// export const BASE_URL = "https://api-inforide-dev.herokuapp.com";
// "https://inforide-server.herokuapp.com";
// export const BASE_URL = "https://inforide-v1.herokuapp.com";
